import ApiClient from "services/api-client.service";

// Estimate history panel (2026-10-24): link opens, signing, staff edits and price changes from the audit log.
// id = estimate id or contract token. Read-only.
export const getEstimateHistory = (id: number | string) => ApiClient.get(`/estimates/${id}/history`);
